import {
  TimeInput as RawTimeInput,
  TimeInputProps as RawTimeInputProps,
} from '@mantine/dates';
import { useFormState } from 'components/elements/form';
import { useController } from 'react-hook-form';

export interface TimeInputProps extends RawTimeInputProps {
  type: 'time';
  name: string;
}

export default function TimeInput(props: TimeInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    placeholder,
    type,
    error,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  return (
    <RawTimeInput
      {...rest}
      {...field}
      type={type}
      value={field.value}
      onChange={(e) => {
        field.onChange(e.target.value);
        onChange?.(e);
      }}
      disabled={_disabled}
      error={_error}
    />
  );
}
